import { render, staticRenderFns } from "./ServicesAffirmativeLetter.vue?vue&type=template&id=9c808db0&scoped=true"
import script from "./ServicesAffirmativeLetter.vue?vue&type=script&lang=js"
export * from "./ServicesAffirmativeLetter.vue?vue&type=script&lang=js"
import style0 from "./ServicesAffirmativeLetter.vue?vue&type=style&index=0&id=9c808db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c808db0",
  null
  
)

export default component.exports